import gql from 'graphql-tag';
import { mutation } from 'services/graphql';

export const collaboratingUserLeftSurfaceMutation = gql`
  mutation collaboratingUserLeftSurface(
    $input: CollaboratingUserLeftSurfaceInput!
  ) {
    collaboratingUserLeftSurface(input: $input)
  }
`;

export default mutation(collaboratingUserLeftSurfaceMutation);
